export const getRouteText = (isAppBarWithoutTaskInfo, route) => (isAppBarWithoutTaskInfo && route[1] && `${route.slice(1)}`) || '';
